import React, { Component } from 'react';
import Logger from '../functions/logging';

import '../static/DestinationPrompt.css';
import TechCheckHeader from '../components/tech-check/TechCheckHeader';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/index';

import Tests from '../components/tech-check/Tests';
import RequestPermission from '../components/tech-check/RequestPermission';
import AccessDenied from '../components/tech-check/AccessDenied';

class TechCheck extends Component {
	constructor(props) {
		super(props);
		this.handlePermission = this.handlePermission.bind(this);
	}

	handlePermission() {
		// Chrome still don't support the PermissionName "speaker-selection" yet
		// so it's not possible to directly request permissions only for speakers.
		// Also, it's not possible to list the available speakers without permission
		// because of this we need the less than optimal workaround of requesting for the "microphone" one instead.
		// If we don't want to ask the user for Microphone permissions, we can remove the list speaker feature and
		// just use the same speaker selected at the operational system, without handling it by ourselves.
		if (navigator.permissions) {
			// navigator.permissions is not supported for Firefox and currently is still in experimental phase for Safari
			// https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API#browser_compatibility
			navigator.permissions.query({ name: 'microphone' }).then((result) => {
				const audioPermissionStatus = this.props.audioPermissionStatus;

				if (result.state !== audioPermissionStatus) {
					this.props.setNavigatorAudioPermission(result.state);
				}
			});
		} else {
			// if navigator.permissions gets supported at Firefox and Safari this else can be removed
			navigator.mediaDevices
				.getUserMedia({ audio: true })
				.then(() => {
					// successfull response, the user granted permissions
					const result = 'granted';
					const audioPermissionStatus = this.props.audioPermissionStatus;

					if (result !== audioPermissionStatus) {
						this.props.setNavigatorAudioPermission(result);
					}
				})
				.catch(() => {
					// the user didn't granted permissions
					const result = 'denied';
					this.props.setNavigatorAudioPermission(result);
				});
		}
	}

	render() {
		Logger.log(this.constructor.name, 'render()', this.props, this.state);

		const audioPermissionStatus = this.props.audioPermissionStatus;
		this.handlePermission();

		return (
			<div className="dp-main-container tech-check">
				<TechCheckHeader
					history={this.props.history}
					styles={{ background: 'transparent', position: 'unset' }}
					disableScroll={true}
				/>

				<div className="dp-instruction-rows">
					{audioPermissionStatus === 'prompt' && <RequestPermission />}
					{audioPermissionStatus === 'granted' && <Tests />}
					{audioPermissionStatus === 'denied' && <AccessDenied />}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	audioPermissionStatus: state.navigatorPermissions.audio,
});

export default connect(mapStateToProps, actions)(TechCheck);



// WEBPACK FOOTER //
// ./src/pages/TechCheck.js